import styled from "styled-components";
import {useContext, useEffect, useRef, useState} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import AccountsList from "./AccountsList";
import {useQuery} from "react-query";
import {accountsFromSf, userDataFromSf} from "../../../../../../../utils/const/query-key";
import apiService from "../../../../../../../api/apiService";
import {accountsTypesHM} from "../../../../../../../utils/const/usersTypes";
import EnvironmentContext from "../../EnvironmentContext";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import StepperContext from "../StepperContext";
import {DebounceInput} from "react-debounce-input";
import CancelIcon from "../../../../../../assets/createEnvAssets/CancelIcon";
import {CircularProgress} from "@mui/material";

export const DropdownSearch = styled(DebounceInput)`
  width: 100%;
  height: 38px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 3px;
  padding-left: 10px;
  border-right-style: none;

  &:focus-visible {
    outline-color: #EC407A;
  }

`;

export const DropDownTabs = styled.div`
  z-index: 1;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 3px;
  position: relative;
  ${props => props.hide && 'visibility: hidden;'}
`;

const TabListStyle = styled(TabList)`
  display: flex;
  list-style: none;
  padding: 0px;
  margin-left: 10px;
  margin-top: 8px;

`;

const TabStyle = styled(Tab)`
  margin-right: 5px;
`;

const CircularProgressWrapper = styled.div`
  position: absolute;
  right: 40px;
  top: 8px;
`


export const AccountCategoryStyle = styled.div`
  text-align: center;
  cursor: pointer;
  width: 65px;
  display: flex;
  padding: 3px;
  align-items: center;
  justify-content: center;
  background: ${props => props.background};
  border-radius: 40px;
  text-align: center;
  color: ${props => props.color};
  font: var(--unnamed-font-style-normal) normal medium 12px/15px DIN Pro;
`

const TabsStyle = styled(Tabs)`
  text-align: center;
`;

export const InputSearch = styled.div`
  display: flex;
  position: relative;

  .delete-search {
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 3px;
    padding-left: 10px;
    border-left-style: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 10px;
  }
`;

const AccountDropdown = (props) => {
    const {setOpportunityValue, setTechnicalEngagementValue} = props;
    const [search, setSearch] = useState("");
    const {
        data: accountsFromSF,
        refetch: reFetchAccountsFromSF,
        isFetching
    } = useQuery(accountsFromSf, () => apiService.getAccountFromSF(search),
        {enabled: false}
    );
    const {data: userDataSF} = useQuery(userDataFromSf, () =>
        apiService.getUserDataSF()
    );
    const menuRef = useRef(null);
    const [listening, setListening] = useState(false);
    const [isHidden, setIsHidden] = useState(true);
    const [accountName, setAccountName] = useState("");
    const {setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const {setEnvironment} = useContext(EnvironmentContext);
    const {customerName, setCustomerName} = useContext(StepperContext);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setAccountName(e.target.value);
    }

    useEffect(() => {
        reFetchAccountsFromSF();
    }, [search, reFetchAccountsFromSF])

    const handleAccountSelection = (name, id,recordTypeName) => {
        setIsHidden(true);
        setTechnicalEngagement(prevState => {
            return {
                ...prevState,
                accountName: id,
                opportunity: "",
                ownerId: userDataSF.length > 0 && userDataSF[0].userId,
                iAnticipateProgressingThisDeal: recordTypeName ===  accountsTypesHM.get("Partner") && "Partner Enablement"
            }
        });
        setEnvironment(prevState => {
            return {
                ...prevState,
                customer_company_name: name,
                salesforceAccountID:id
            }
        });
        setAccountName(name + " (#" + id + ")");
        setOpportunityValue({});
        setTechnicalEngagementValue({});
        setCustomerName(name + " (#" + id + ")");
        setSearch(name)
    }

    const filterSearchAccount = (category) => {
        return accountsFromSF?.filter(account => {
            return ((category === "" || category === accountsTypesHM.get(account.recordType.recordTypeName)) && account
            )
        });
    }

    useEffect(() => {
        if (listening) return;
        if (!menuRef.current) return;
        setListening(true);
        [`click`, `touchstart`].forEach(() => {
            document.addEventListener(`click`, (evt) => {
                if (menuRef?.current?.contains(evt.target)) return;
                setIsHidden(true);
            });
        });
    }, [listening]);

    const deleteSearch = () => {
        setAccountName("");
        setCustomerName("");
        setSearch("");
    }

    return (
        <div ref={menuRef} id={"accounts_dropdown"}>
            <InputSearch className={"account-input"}>
                {isFetching && <CircularProgressWrapper>
                    <CircularProgress size={20} />
                </CircularProgressWrapper>}
                <DropdownSearch onClick={() => setIsHidden(false)}
                                type={"text"}
                                placeholder={"Start Typing Account Name"}
                                minLength={3}
                                debounceTimeout={800}
                                onChange={handleSearch}
                                value={accountName !== "" ? accountName : customerName}
                                id={"account_search"}
                                autoComplete={"off"}
                />
                <div className={"delete-search"} onClick={deleteSearch}>
                    <CancelIcon/>
                </div>
            </InputSearch>
            <DropDownTabs hide={isHidden}>
                <TabsStyle selectedTabClassName={"selected"}>
                    <TabListStyle>
                        <TabStyle>
                            <AccountCategoryStyle id={"all_tab"} background={"#FDEBF1"} color={"#EC407A"}>
                                All
                            </AccountCategoryStyle>
                        </TabStyle>
                        <TabStyle>
                            <AccountCategoryStyle id={"official_tab"} background={"#E7F5E6"} color={"#4C9E3A"}>
                                Official
                            </AccountCategoryStyle>
                        </TabStyle>
                        <TabStyle>
                            <AccountCategoryStyle id={"partner_tab"} background={"#DCEEFB"} color={"#0F609B"}>
                                Partner
                            </AccountCategoryStyle>
                        </TabStyle>
                        <TabStyle>
                            <AccountCategoryStyle id={"prospect_tab"} background={"#F2EBFE"} color={"#690CB0"}>
                                Prospect
                            </AccountCategoryStyle>
                        </TabStyle>
                    </TabListStyle>
                    <TabPanel>
                        <AccountsList accounts={filterSearchAccount("")} category={""}
                                      setHide={handleAccountSelection}/>
                    </TabPanel>
                    <TabPanel>
                        <AccountsList accounts={filterSearchAccount("Official")} category={"Official"}
                                      setHide={handleAccountSelection}/>
                    </TabPanel>
                    <TabPanel>
                        <AccountsList accounts={filterSearchAccount("Partner")} category={"Partner"}
                                      setHide={handleAccountSelection}/>
                    </TabPanel>
                    <TabPanel>
                        <AccountsList accounts={filterSearchAccount("Prospect")} category={"Prospect"}
                                      setHide={handleAccountSelection}/>
                    </TabPanel>
                </TabsStyle>
            </DropDownTabs>
        </div>
    );
}

export default AccountDropdown;
